import { translate } from "../../../utils/Common";
import { useLocation } from "react-router-dom";
import CounterInsights from "./CounterInsights";
import { useEffect, useState } from "react";
import { FaChartBar } from "react-icons/fa";
import YearMonthSelect from "../../../components/YearMonthSelect";
import PageContainer from "../../../components/layout/PageContainer";
import PageHeader from "../../../components/layout/PageHeader";
import styles from "./Insights.module.css";
import { verifyAccessViewPermissions } from "../../../config/permissions";

const Insights = () => {
  const [dateSelect, setDateSelect] = useState(null);
  const location = useLocation();
  const permissionsPath = "/dashboard/insights";
  const canReadFilters = verifyAccessViewPermissions(["read-insights-filters"], {
    path: permissionsPath || location.pathname,
  });

  const handleSelection = (selection) => {
    setDateSelect(selection);
  };

  useEffect(() => {
    handleSelection({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
    });
  }, []);

  const headerActions = (
    canReadFilters ? (
      <YearMonthSelect
        onSelect={handleSelection}
        objSelect={dateSelect}
        showMonths={false}
      />
    ) : null
  );

  return (
    <PageContainer>
      <PageHeader
        title={translate("dashboard.insights.title")}
        subtitle={translate("dashboard.insights.message")}
        icon={<FaChartBar size={24} />}
        actions={headerActions}
      />
      <div className={styles.pageContent}>
        <CounterInsights yearSelect={dateSelect?.year} canReadFilters={canReadFilters} />
      </div>
    </PageContainer>
  );
};

export default Insights;
